// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1q9nd","content":"ManualTimeModal_content__3nNDV"};